import { observer } from 'mobx-react-lite';
import Camera from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';
import { Image } from 'semantic-ui-react';
import { useStore } from '../../stores/store';
import { useState } from 'react';

function PhotoCam() {
  const { dashboardStore } = useStore();
  const [preview, setpreview] = useState<File[]>([]);

  function handleTakePhoto(dataUri: any) {
    setpreview([...preview, dataUri]);
    const arr = dataUri.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    var n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    dashboardStore.setcamImageBase64([
      ...dashboardStore.dashboard.camImageBase64,
      new Blob([u8arr], { type: mime }),
    ]);
  }

  return (
    <>
      <Camera
        onTakePhoto={(dataUri:any) => {
          handleTakePhoto(dataUri);
        }}
        idealFacingMode="environment"
        // imageType = {IMAGE_TYPES.JPG}
        imageCompression={0.92}
      />
      <div
        className="photocamimg"
        //  style={{display:"flex",maxWidth:"100%",overflowX:"scroll"}}
      >
        {preview.map((blob, i) => (
          <Image key={i} style={{ height: '120px' }} src={blob} />
        ))}
      </div>
    </>
  );
}

export default observer(PhotoCam);
